export default __webpack_public_path__ + "static/media/Faded.16302f5f.mp3";